import FirebaseContext from "./context";
import { Firebase } from "./firebase";
import useFirebaseAuthentication from "./hooks";

export default Firebase;

export { FirebaseContext, useFirebaseAuthentication };
